import "@/lazysizes";
import "@/styles/scss/style.scss";
import moment from "moment";
import Vue from "vue";
import VueMoment from "vue-moment";
import App from "./App.vue";
import i18n from "./i18n";
import router from "./router";
import store from "./store";
import VueAnalytics from "vue-analytics";

Vue.config.productionTip = false;

moment.locale(i18n.locale);
Vue.use(VueMoment, { moment });

const LazyLoad = require("vue-lazyload").default;
Vue.use(LazyLoad);

Vue.use(VueAnalytics, {
  id: "UA-32470020-2",
  router
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
